export const DEVELOPMENT_URL="https://api.dailoride.com/";
export const PRODUCTION_URL="https://api.dailoride.com/";

export const ADMIN_LOGIN_URL="api/admin/login";
export const DASHBOARD_DETAILS="api/admin/get-dashboard-detail";
export const GET_MONTHLY_SALES="api/admin/get-monthly-sales";
export const GET_ADMIN_DETAILS="api/admin/admin-detail";
export const GET_ALL_CUSTOMERS="api/admin/get-all-users?page=";
export const GET_ALL_RIDERS="api/admin/get-all-riders?page=";
export const GET_RIDE_RATE_PER_KM="api/admin/get-all-rate-list";
export const UPDATE_RIDE_RATE_PER_KM="api/admin/update-vehicle-rate";
export const GET_COMMISSION_OF_RIDE="api/admin/get-commission-payment/";
export const GET_RIDER_RIDE_HISTORY="api/get-commission-amount-by-rider-id/";
export const ADD_RIDER_COMMISSION_PAID_AMOUNT='api/admin/add-commission-payment';
export const UPDATE_RIDER_COMMISSION_PAID_AMOUNT='api/admin/update-rider-commission-payment/';
export const GET_CUSTOMER_DETAIL="api/admin/customer/user-detail/";
export const GET_RIDER_DETAIL="api/admin/rider/rider-detail/";
export const GET_DOCUMENT_DETAIL="api/admin/rider/document-detail/";
export const UPDATE_DOCUMENT_DETAIL="api/admin/rider/update-rider-document/";
export const DELETE_CUSTOMER="api/admin/delete-user/";
export const DELETE_RIDER="api/admin/delete-rider/";
export const GET_ALL_RIDE="api/completed/ride";
export const GET_RIDE_RATE_PER_KM_WITH_COMMISSION_PERCENTAGE="api/get-all-rate-list-with-commission";
export const UPLOAD_PROFILE_PICTURE="api/upload-image";
export const UPDATE_ADMIN_DETAILS="api/admin/update-profile";
export const DELETE_COMMISSION_PAYMENT="api/admin/delete-commission-payment/";
export const GET_ALL_COMPLETED_RIDE="api/admin/get-all-completed-ride";
export const GET_ALL_DISTRICT="api/get-available-districts";
export const ADD_DISTRICT="api/admin/add-district";
export const DELETE_DISTRICT="api/admin/district/";
export const ALL_RIDER_NAME="api/admin/get-all-rider-name";